/* eslint-disable @typescript-eslint/no-unused-vars */

import { Assembly } from '@carbon/icons-react'
import { Handle, Position, useReactFlow } from '@xyflow/react'
import { useCallback, useEffect, useRef, useState } from 'react'

function GenericNode({ id, data, isConnectable }) {
  const { setNodes } = useReactFlow()
  const [componentName, setComponentName] = useState(data?.name || 'Generic')
  const textareaRef = useRef<HTMLTextAreaElement>(null)

  // Update node data when name changes
  const updateNodeName = useCallback(
    (newName: string) => {
      setNodes((nodes) =>
        nodes.map((node) => {
          if (node.id === id) {
            return {
              ...node,
              data: {
                ...node.data,
                name: newName,
              },
            }
          }
          return node
        }),
      )
    },
    [id, setNodes],
  )

  // Auto-resize textarea based on content
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto'
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`
    }
  }, [componentName])

  return (
    <div className="pg-generic-node">
      <Handle type="target" position={Position.Left} id="ta" className="pg-target-connection" />
      <Handle type="target" position={Position.Right} id="tb" className="pg-target-connection" />
      <Handle type="target" position={Position.Bottom} id="tc" className="pg-target-connection" />
      <Handle type="target" position={Position.Top} id="td" className="pg-target-connection" />

      <Handle type="source" position={Position.Right} id="sa" className="pg-source-connection" />
      <Handle type="source" position={Position.Left} id="sb" className="pg-source-connection" />
      <Handle type="source" position={Position.Bottom} id="sc" className="pg-source-connection" />
      <Handle type="source" position={Position.Top} id="sd" className="pg-source-connection" />
      <Assembly size={32} className="pg-icon" />
      <div className="pg-generic-text">
        <textarea
          ref={textareaRef}
          id="text"
          name="componentName"
          onChange={(e) => {
            setComponentName(e.target.value)
            updateNodeName(e.target.value)
          }}
          value={componentName}
          className="nodrag pg-node-textarea"
          rows={1}
        />
      </div>
    </div>
  )
}

export default GenericNode
